import { createFileRoute, redirect } from "@tanstack/react-router";

/** Legacy slug — permanent redirect to the canonical EN URL. */
export const Route = createFileRoute("/retail-profitability-calculator")({
  beforeLoad: () => {
    throw redirect({ to: "/en/tools/calculator", statusCode: 301 });
  },
});
